var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "form-check" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.checked,
          expression: "checked"
        }
      ],
      staticClass: "form-check-input",
      attrs: { type: "checkbox", id: _vm.uid + "checkbox" },
      domProps: {
        checked: Array.isArray(_vm.checked)
          ? _vm._i(_vm.checked, null) > -1
          : _vm.checked
      },
      on: {
        change: function($event) {
          var $$a = _vm.checked,
            $$el = $event.target,
            $$c = $$el.checked ? true : false
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v)
            if ($$el.checked) {
              $$i < 0 && (_vm.checked = $$a.concat([$$v]))
            } else {
              $$i > -1 &&
                (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checked = $$c
          }
        }
      }
    }),
    _vm._v(" "),
    _c(
      "label",
      { staticClass: "form-check-label", attrs: { for: _vm.uid + "checkbox" } },
      [_vm._v("\n    " + _vm._s(_vm.entry.text) + "\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }